import { action, makeObservable } from 'mobx'

export default class FutureTaxCreditDeliveryMethodEditorViewModel {
  constructor() {
    makeObservable(this)
  }

  @action.bound
  validate() {
    return true
  }

  @action.bound
  reset() {
    // No fields — picking this method is the entire action.
  }
}
